/**
 * 将按钮样式绘制为透明底 PNG（dataURL / Blob）
 */
/** 未选颜色、透明、alpha=0 时不绘制背景，避免回落到默认蓝 */
export function isTransparentFill(color) {
  if (color == null || color === "") {
    return true;
  }
  const s = String(color).trim().toLowerCase();
  if (!s || s === "transparent" || s === "none") {
    return true;
  }
  const rgba = s.match(
    /^rgba?\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+(?:\s*,\s*([\d.]+))?\s*\)$/
  );
  if (rgba) {
    if (rgba[1] == null) {
      return false;
    }
    return Number(rgba[1]) === 0;
  }
  if (/^#([0-9a-f]{4})$/.test(s)) {
    return parseInt(s.charAt(4), 16) === 0;
  }
  if (/^#([0-9a-f]{8})$/.test(s)) {
    return parseInt(s.slice(7, 9), 16) === 0;
  }
  return false;
}

function roundRect(ctx, x, y, w, h, r) {
  const radius = Math.max(0, Math.min(Number(r) || 0, w / 2, h / 2));
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius);
  ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius);
  ctx.closePath();
}

export function getCssFontFamily(fontFamilyId) {
  const map = {
    "1": "diy-kongxin",
    "2": "diy-sysRegular",
    "3": "diy-sysSemiBold",
    "4": "diy-sysSourceHanSans",
    "5": "diy-syht",
    "7": "diy-mkpyxk",
    "8": "diy-arialUnicode",
    "9": "diy-arialBold",
  };
  return map[String(fontFamilyId)] || "Microsoft YaHei, sans-serif";
}

export function drawButtonToCanvas(opts) {
  const width = Math.max(8, Math.round(Number(opts.width) || 100));
  const height = Math.max(8, Math.round(Number(opts.height) || 34));
  const dpr = 2;
  const canvas = document.createElement("canvas");
  canvas.width = width * dpr;
  canvas.height = height * dpr;
  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  ctx.clearRect(0, 0, width, height);

  const opacity = opts.opacity == null ? 1 : Number(opts.opacity);
  ctx.globalAlpha = Math.min(1, Math.max(0, opacity));

  let radius = Number(opts.borderRadius) || 0;
  if (opts.shape === "round") {
    radius = Math.min(width, height) / 2;
  }

  roundRect(ctx, 0.5, 0.5, width - 1, height - 1, radius);
  if (!isTransparentFill(opts.backgroundColor)) {
    ctx.fillStyle = opts.backgroundColor;
    ctx.fill();
  }

  const borderWidth = Number(opts.borderWidth) || 0;
  if (borderWidth > 0) {
    ctx.lineWidth = borderWidth;
    ctx.strokeStyle = opts.borderColor || "#ffffff";
    ctx.stroke();
  }

  const text = (opts.text || "").trim();
  if (text) {
    const fontSize = Number(opts.fontSize) || 14;
    const fontWeight = opts.fontWeight || 500;
    const family = getCssFontFamily(opts.fontFamily);
    ctx.fillStyle = opts.color || "#ffffff";
    ctx.font = `${fontWeight} ${fontSize}px ${family}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, width / 2, height / 2 + 0.5, width - 12);
  }

  ctx.globalAlpha = 1;
  return canvas;
}

export function canvasToPngDataUrl(canvas) {
  return canvas.toDataURL("image/png");
}

export function dataUrlToBase64(dataUrl) {
  const i = String(dataUrl).indexOf(",");
  return i >= 0 ? dataUrl.slice(i + 1) : dataUrl;
}

export function downloadDataUrl(dataUrl, fileName) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = fileName.endsWith(".png") ? fileName : `${fileName}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
